import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { CreateType } from "../../../models/upload-type";
import { breadCrumbsState } from "../../../store/layout";
import startUpper from "../../../utils/start-upper";

type IProps = {
	formId?: string;
	formType?: string;
	isRecordDrawer?: boolean;
};

export const useSetFormBreadcrumbs = (props: IProps) => {
	const { formType, formId, isRecordDrawer } = props;
	const [, setBreadCrumbs] = useRecoilState(breadCrumbsState);
	const { t } = useTranslation();
	const isRecord = formType === CreateType.ClaimRecord || formType === CreateType.PurchaseRecord

	useEffect(() => {
		!isRecordDrawer &&
			setBreadCrumbs({
				fromProps: true,
				links: [
					{
						label: startUpper(t("data")),
						link: "/data",
					},
					{
						label: startUpper(t(isRecord ? "records" : "forms")),
						link: `/data/${isRecord ? "records" : "forms"}`,
					},
					{
						label: formId ? formId || "" : (t(formType || "") as string),
						link: undefined,
					},
				],
			});
		return () => setBreadCrumbs(null);
	}, [formType]);
};
